import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import MegaMenu from './MegaMenu';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { direction } = useTheme();

  return (
    <div className={`min-h-screen bg-gradient-to-br from-orange-50 to-orange-100 dark:from-gray-900 dark:to-gray-800 transition-colors duration-300 ${direction === 'rtl' ? 'font-farsi' : ''}`}>
      {/* Mega Menu - Available on all pages */}
      <MegaMenu />



      {/* Main Content */}
      <main className="max-w-none mx-auto px-4 sm:px-6 lg:px-8 py-8 pt-24">
        {children}
      </main>
    </div>
  );
};

export default Layout; 